import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { ViewUser, ViewUserDefaultValues } from 'src/app/components/users/view-user';
import { AuthService } from 'src/app/services/auth.service';
import { ModalService } from 'src/app/services/modal.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-view-user',
    templateUrl: './view-user.component.html',
    styleUrls: ['./view-user.component.scss'],
    standalone: false
})
export class ViewUserComponent {

  viewUser: ViewUser = ViewUserDefaultValues();
  userId: string = '';
  auditLogs: any[] = [];
  modalSub!: Subscription;

  modalOpen = this._modalservice.getModalState();
  modalContent = '';
  modalTitle = '';
  modalOkButtonValue = 'OK';
  modalCancelButtonValue = 'CANCEL';
  modalOkButtonText = 'Ok';
  modalCancelButtonText = 'Cancel';
  contentInnerHTML = "";
  pageName = CheckPageAccess.USERMANAGEMENT;
  showeditbutton = true;
  showDeleteButton = true;
  roleColumns = ['roleName', 'roleAssigned'];
  specialPermissionColumns = ['id', 'courseName', 'programs', 'accessGranted', 'grantedBy'];
  recommendedCourseColumns = ['id', 'courseName', 'programs', 'dateAssigned'];

  getUserDisplayName(): string {
    if (this.viewUser.isParticipant) {
      return this.viewUser.displayName || 'Participant';
    }

    const fullName = `${this.viewUser.firstName || ''} ${this.viewUser.lastName || ''}`.trim();
    return fullName || 'User';
  }

  constructor(private userservice: UserService,
    private route: ActivatedRoute,
    private _modalservice: ModalService,
    private router: Router,
    private _toastservice: ToastService,
    private authservice: AuthService)
  {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userId = params['id'];
      this.userservice.getUserDetailsForView(this.userId).subscribe({
        next:(data) => {
          this.viewUser = data;
          this.getAuditLogs(this.userId);
        }
      });
    });

    this.showeditbutton = this.authservice.getAccessControl().editUser;
    this.showDeleteButton = this.authservice.getAccessControl().deleteUser;
    this.afterConfirmModalOps();
  }

  getAuditLogs(id: string) {
    this.userservice.getUserAuditLogs(this.userId).subscribe({
      next: (res) => {
        this.auditLogs = res;
      }
    });
  }

  navigate() {
    this.router.navigateByUrl('/edit-user/'+this.userId)
  }

  deleteUser() {
    this.askConfirmation("Yes, Delete",
      "YES",
      "No, Cancel",
      "NO",
      "Are you sure you want to permanently delete this User?",
      "Delete User");
  }

  askConfirmation(
        okButtonText: string,
        okButtonValue: string,
        cancelButtonText: string,
        cancelButtonValue: string,
        content: string,
        title: string) {
      this.modalContent = content;
      this.modalTitle = title;
      this.modalOkButtonValue = okButtonValue;
      this.modalCancelButtonValue = cancelButtonValue;
      this.modalOkButtonText = okButtonText;
      this.modalCancelButtonText = cancelButtonText;

      this._modalservice.openModal();
    }

    afterConfirmModalOps() {
      this.modalSub = this._modalservice
        .getButtonClicked()
        .subscribe((button) => {
          switch (button) {
            case 'YES':
              this.userservice.deleteUser(this.userId).subscribe({
                next: (response: any) => {
                  this._toastservice.showMessage("User Deleted Successfully");
                  this.router.navigate(['/user-list']);
                }
              });
              break;
            default:
              this._modalservice.closeModal();
          }
        });
    }

    ngOnDestroy(): void {
      if (this.modalSub) {
        this.modalSub.unsubscribe();
      }
    }

}
